import {Controller} from "@hotwired/stimulus"

export default class ConfirmationController extends Controller {
  static values = {
    url: String,
    turbo: Boolean,
    method: {type: String, default: "delete"},
    title: String,
    text: String,
    icon: String,
    confirmText: String,
    confirmColor: String,
    cancelColor: String,
    redirectUrl: String
  }

  connect() {
    this.element.addEventListener("click", this.handleClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick)
  }

  handleClick = (event) => {
    event.preventDefault()
    this.confirm(event)
  }

  hideAllTooltip(){
    document.querySelectorAll('.tooltip').forEach((tooltip) => {
      tooltip.remove()
    })
  }

  confirm(event) {
    const form = event.target.closest("form")
    const mainUrl = this.urlValue || event.currentTarget.getAttribute("href")

    if (form && typeof $(form).valid === "function" && !$(form).valid()) return

    Swal.fire({
      customClass: {
        popup: 'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
        htmlContainer: 'text-black-paint text-white'
      },
      animation: false,
      title: this.titleValue || "Are you sure?",
      text: this.textValue || "You won't be able to revert this!",
      icon: this.iconValue || "warning",
      showCancelButton: true,
      confirmButtonColor: this.confirmColorValue || "#3085d6",
      cancelButtonColor: this.cancelColorValue || "#d33",
      confirmButtonText: this.confirmTextValue || "Yes",
      didOpen: () => {
        this.hideAllTooltip();
      }
    }).then(result => {
      if (result.isConfirmed) {
        const dispatchEvent = event?.target?.dataset?.dispatchEvent;
        if (dispatchEvent) this.dispatchEvent(dispatchEvent);

        form ? form.requestSubmit() : this.sendRequest(mainUrl);
        return;
      }

      const disabledClass = this.element?.dataset?.disabledElement;
      if (!disabledClass) return;

      const disabledElement = this.element.closest("." + disabledClass);
      if (disabledElement) {
        disabledElement.style.cursor = 'pointer';
        const disableController = this.application.getControllerForElementAndIdentifier(disabledElement, 'disable-click')
        disableController?.enable()
      }
    })
  }

  sendRequest(url) {
    fetch(url, {
      method: this.methodValue.toUpperCase(),
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
        Accept: this.turboValue ? "text/vnd.turbo-stream.html" : "text/html",
        "Content-Type": "application/json"
      }
    }).then(response => {
      if (this.turboValue) {
        return response.text().then(html => Turbo.renderStreamMessage(html))
      } else if (this.hasRedirectUrlValue) {
        globalThis.location.href = this.redirectUrlValue
      } else if (response.redirected) {
        globalThis.location.href = response.url
      }
    })
  }

  dispatchEvent(name, detail = {}) {
    const event = new CustomEvent(name, {detail})
    document.dispatchEvent(event)
  }
}